<template>
  <div class="journals container content">
    <h1>Journals</h1>
    <div
      v-if="enrollments && enrollments.length"
    >
      <div
        v-for="program in enrollments"
        :key="program.id"
        class="card m-4"
      >
        <div class="card-header">
          <h5 class="card-title">
            {{ program.title }}
          </h5>
        </div>
        <div class="card-body d-flex flex-wrap justify-content-between flex-column flex-md-row">
          <button
            class="btn"
            @click="openJournal('belief', program.id)"
          >
            Belief
          </button>
          <span />
          <button
            class="btn"
            @click="openJournal('essence', program.id)"
          >
            Essence
          </button>
          <span />
          <button
            class="btn"
            @click="openJournal('how', program.id)"
          >
            The How
          </button>
          <span />
          <button
            class="btn"
            @click="openJournal('target', program.id)"
          >
            The Target
          </button>
        </div>
        <div class="card-footer">
          <div class="">
            Started {{ program.created | formatDate }}
          </div>
        </div>
      </div>
    </div>
    <div
      v-else-if="loading"
      class="text-center"
    >
      <p>Loading journals...</p>
    </div>
    <p v-else>
      {{ noJournalsMessage }}
    </p>
  </div>
</template>

<script>
import moment from 'moment';
import api from '@/utils/api';

export default {
  name: 'Journals',
  filters: {
    formatDate(value) {
      if (!value) return '';
      return moment(value).format('MM/DD/YYYY');
    },
  },
  data() {
    return {
      enrollments: [],
      loading: false,
    };
  },
  computed: {
    userData() {
      return this.$store.state.userData;
    },
    noJournalsMessage() {
      if (this.userData && this.userData.client && this.userData.client.slug) {
        return 'No journals found for this client.';
      }
      return 'No journals found.';
    },
  },
  watch: {
    // Re-fetch if the user data changes (e.g. login/logout or client switch)
    userData: {
      handler(val) {
        if (val) this.fetchEnrollments();
      },
      deep: true,
      immediate: true,
    },
  },
  methods: {
    openJournal(category, enrollmentId) {
      this.$store.commit('activeJournalCategory', category);
      this.$store.commit('activeJournalProgram', enrollmentId);
    },
    async fetchEnrollments() {
      if (!this.userData) return;

      this.loading = true;
      try {
        // 1. Build URL for the User Enrollments endpoint
        let url = `users/${this.userData.id}/enrollments/`;

        // 2. Check for Client Slug to filter
        if (this.userData.client && this.userData.client.slug) {
          url += `?client_slug=${this.userData.client.slug}`;
        }

        const response = await api({
          url,
          method: 'GET',
          headers: {
            Authorization: `Token ${this.userData.drf_token}`,
          },
        });

        if (response.ok) {
          this.enrollments = response.body;
        }
      } catch (e) {
        // Error fetching journals - silently handle
      } finally {
        this.loading = false;
      }
    },
    // Helper for date if the filter above isn't preferred
    date(val) {
      return moment(val).format('MM/DD/YYYY');
    },
  },
};
</script>

<style lang="scss" scoped>
.journals {
  max-width: 600px;
}
button:hover {
  color: var(--primary);
}
</style>
